package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Site(
    @SerialName("_id") var id: String? = null,
    @SerialName("personName") var personName: String? = null,
    @SerialName("addressObject") var addressObject: AddressObject? = null,
    @SerialName("personPhone") var personPhone: String? = null,
    @SerialName("siteName") var siteName: String? = null,
    @SerialName("parentId") var parentId: String? = null,
    @SerialName("parentName") var parentName: String? = null,
    @SerialName("personEmail") var personEmail: String? = null,
    @SerialName("workspaceId") var workspaceId: String? = null
) {
    fun isDifferent(other: Site): Boolean {
        val differences = mutableListOf<String>()

        if (this.id != other.id) differences.add("id: '${this.id}' vs '${other.id}'")
        if (this.personName != other.personName) differences.add("personName: '${this.personName}' vs '${other.personName}'")
        if (this.addressObject != other.addressObject) differences.add("addressObject: '${this.addressObject}' vs '${other.addressObject}'")
        if (this.personPhone != other.personPhone) differences.add("personPhone: '${this.personPhone}' vs '${other.personPhone}'")
        if (this.siteName != other.siteName) differences.add("siteName: '${this.siteName}' vs '${other.siteName}'")
        if (this.parentId != other.parentId) differences.add("parentId: '${this.parentId}' vs '${other.parentId}'")
        if (this.parentName != other.parentName) differences.add("parentName: '${this.parentName}' vs '${other.parentName}'")
        if (this.personEmail != other.personEmail) differences.add("personEmail: '${this.personEmail}' vs '${other.personEmail}'")
        if (this.workspaceId != other.workspaceId) differences.add("workspaceId: '${this.workspaceId}' vs '${other.workspaceId}'")

        if (differences.isNotEmpty()) {
            println("Site differences found for site '${this.siteName}' (${this.id}):")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}
